import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const CATEGORY_OVERVIEW_REQUEST = 'FETCH_CATEGORY_OVERVIEW_REQUEST';
export const CATEGORY_OVERVIEW_FAILURE = 'FETCH_CATEGORY_OVERVIEW_FAILURE';
export const CATEGORY_OVERVIEW_SUCCESS = 'FETCH_CATEGORY_OVERVIEW_SUCCESS';

/**
 * Category Workspace read model: identity, athlete/fight counts, estimated
 * duration, WORKFLOW STATUS (NEW / DRAW_CREATED / IN_PROGRESS / FINISHED)
 * and the winner. The status drives which workspace tabs are available;
 * the reducer drops the cached entry whenever a mutation (draw, winner,
 * result edit, category close) touches the category, so it refetches fresh.
 */
export const fetchCategoryOverview = (competition, category) => {
    return function(dispatch) {
        dispatch({ type: CATEGORY_OVERVIEW_REQUEST, competition, category });
        return axios(apiRequestOptions(apiPath.CATEGORY_WORKSPACE.OVERVIEW, null, { params: { competition, category } }))
            .then(transformHttpResponse)
            .then(response => {
                dispatch({ type: CATEGORY_OVERVIEW_SUCCESS, competition, category, data: response.data });
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch({ type: CATEGORY_OVERVIEW_FAILURE, competition, category, error });
                dispatch(errorRequestHandler(error));
            });
    }
};
